import { render, staticRenderFns } from "./RoleDetails.vue?vue&type=template&id=f34a3d86&scoped=true&"
import script from "./RoleDetails.vue?vue&type=script&lang=js&"
export * from "./RoleDetails.vue?vue&type=script&lang=js&"
import style0 from "./RoleDetails.vue?vue&type=style&index=0&id=f34a3d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34a3d86",
  null
  
)

export default component.exports